import { Component, OnInit, HostListener } from '@angular/core';
import { ModalService } from '../modal.service';
import { PrintService } from '../../_services/print.service';
import { CaptainWalletService } from 'src/app/_services/captainwallet.service';

@Component({
    selector: 'ng-casto-display-barcode',
    templateUrl: './display-barcode.component.html'
})
export class DisplayBarcodeComponent implements OnInit {
    barcodeValue: string;
    title: string;
    subtitle: string;
    icon: string;
    printLabel: string = 'Imprimer';

    constructor(
        public modalService: ModalService,
        private printService: PrintService,
        private captainWalletService: CaptainWalletService
    ) { }

    ngOnInit(): void {
        this.updateLabel();
        this.barcodeValue = this.modalService.currentDatas.barcodeValue;
        this.icon = this.modalService.currentDatas.icon;
        this.title = this.modalService.currentDatas.title;
        this.subtitle = this.modalService.currentDatas.subtitle;

        const iconEl = document.getElementById('icon');
        iconEl.innerHTML = '<svg><use xlink:href="' + this.icon + '"></use></svg>';

        const div = document.createElement("div");
        div.innerHTML = this.printService.createBarCode(this.barcodeValue);
        document.getElementById('barcode')?.appendChild(div);
    }

    print() {
        if (this.canAddToWallet()) {
            this.addToWallet();
        } else {
            this.printService.printBarcode(this.title, this.barcodeValue, undefined, this.subtitle);
        }
    }

    updateLabel() {
        if (this.canAddToWallet()) {
            this.printLabel = 'Ajouter à mon smartphone';
        } else {
            this.printLabel = 'Imprimer';
        }
    }

    /**
     * Sans configuration CaptainWallet sur l'environnement, l'URL générée serait invalide :
     * on retombe alors sur l'impression.
     */
    private canAddToWallet(): boolean {
        return this.isMobileDevice() && this.captainWalletService.isConfigured();
    }

    private isMobileDevice(): boolean {
        const ua = navigator.userAgent || navigator.vendor || (window as any).opera;
        return /android|iphone|ipad|ipod/i.test(ua);
    }

    @HostListener('window:resize')
    onResize() {
        this.updateLabel();
    }

    public addToWallet() {
        const url = this.captainWalletService.generateUrl(this.barcodeValue, 'home');
        window.open(url, '_blank')?.focus();
    }
}
